import $ from "jquery";

/**
 * Counter extension (TODO: Grid compatibility)
 */
export function Counter(Splide, Components, options) {
	// options
	const defaults = {
		counter: false,
		counterContent: function (current, total) {
			return `<span class="splide__counter--current">${current}</span> • <span class="splide__counter--total">${total}</span>`;
		}
	};
	options = $.extend(true, {}, defaults, options);

	// dom
	const $slider = $(Components.Elements.root);
	const $track = $(Components.Elements.track);
	let $counter = $();
	
	function init() {
		if (!options.counter) return false;

		// add elements
		$counter = $('<div>', {class: 'splide__counter'});
		$track.parent().append($counter);

		// initial content
		updateContent();

		events();
	}

	function events() {
		// moved event
		Splide.off('moved.Counter');
		Splide.on('moved.Counter', (newIndex) => {
			updateContent();
		});

		// updated - used for breakpoints
		Splide.off('updated.Counter');
		Splide.on('updated.Counter', () => {
			destroy();
			mount();
		});
	}

	function updateContent(current, total) {
		// current = current || Splide.index + 1;
		// total = total || Splide.length;
		current = current || Components.Controller.toPage(Components.Controller.getIndex()) + 1;
		total = total || Components.Controller.hasFocus() ? Components.Controller.getEnd() + 1 : Math.ceil(Splide.length / options.perPage);

		$counter.html(options.counterContent(current, total));
	}

	function mount() {
		init();
	}

	function destroy() {
		if ($counter.length > 0) {
			$counter.remove();
		}
	}

	return {
		mount,
		destroy,
	};
}

/**
 * Progress bar extension (TODO: Grid compatibility)
 */
export function Steps(Splide, Components, options) {
	// options
	const defaults = {
		steps: false,
	};
	options = $.extend(true, {}, defaults, options);

	// dom
	const $slider = $(Components.Elements.root);
	const $track = $(Components.Elements.track);
	let $steps = $();
	let $stepsBar = $();
	
	function init() {
		if (!options.steps) return false;

		// add elements
		$steps = $('<div>', {class: 'splide__steps'});
		$stepsBar = $('<div>', {class: 'splide__steps--bar'});
		$steps.append($stepsBar);
		$track.parent().append($steps);

		// initial steps
		updateSteps();

		events();
	}

	function events() {
		// moved event
		Splide.off('moved.Progress');
		Splide.on('moved.Progress', (newIndex) => {
			updateSteps();
		});

		// updated - used for breakpoints
		Splide.off('updated.Progress');
		Splide.on('updated.Progress', () => {
			destroy();
			mount();
		});
	}

	function updateSteps(current, total) {
		// current = current || Splide.index + 1;
		// total = total || Splide.length;
		current = current || Components.Controller.toPage(Components.Controller.getIndex()) + 1;
		total = total || Components.Controller.hasFocus() ? Components.Controller.getEnd() + 1 : Math.ceil(Splide.length / options.perPage);

		const percent = (current / total) * 100;
		$stepsBar.css('width', percent + '%');
	}

	function mount() {
		init();
	}

	function destroy() {
		if ($steps.length > 0) {
			$steps.remove();
		}
	}

	return {
		mount,
		destroy,
	};
}

/**
 * Adjustable Height 
 */
export function AdjustableHeight( Splide, Components, options) {

	// Useful elements
	const track = Components.Elements.track;
	const list = Components.Elements.list;
  
	// Custom options or using defaults
	const defaults = {
	  	'whileSliding': true,
	  	'speed': '0.4s',
	}
  
	let settings = defaults;
	const custom = options.adjustableHeight;
  
	if (custom) {
	  	settings.whileSliding = custom.whileSliding ?? defaults.whileSliding;
	  	settings.speed = custom.speed ?? defaults.speed;
	}
  
	function mount() {
		const eventType = settings.whileSliding ? 'move active resize' : 'active resized';
		Splide.on( eventType, adjustHeight );
	}
  
	function adjustHeight() {
		if (!options.adaptiveHeight) return;
		// When "whileSliding" is true it means altering the track element, when false means altering the list
		let element = settings.whileSliding ? track : list;
		let slideHeight = Components.Slides.getAt( typeof( newIndex ) == 'number' ? newIndex : Splide.index ).slide.offsetHeight;

		// If changing track height, add additional padding on the track element to the total height
		let trackStyle = track.currentStyle || window.getComputedStyle(track);
		let trackPadding = parseInt(trackStyle.paddingTop) + parseInt(trackStyle.paddingBottom);
		let totalHeight = (settings.whileSliding) ? slideHeight + trackPadding : slideHeight;

		// Let flex items have individual heights
		list.style.alignItems = 'flex-start';

		// Set transition and height
		element.style.transition = 'height ' + settings.speed;
		element.style.height = totalHeight + 'px';
	}
  
	return {
		mount,
	};
  }